import React from "react";
import { Image } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Modal from "react-modal";

const customStyles = {
  content: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
  },
};

export const ReservationCalenderModel = ({
  open,
  openModal,
  closeModal,
  onChange,
  value,
}) => {
  return (
    <React.Fragment>
      <Image
        fluid
        className="calendar-image"
        src={require("../../../../assets/images/ActionImages/calendar.png")}
        alt="calendar"
        title="calendar"
        onClick={openModal}
      />
      <Modal
        isOpen={open}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className="inside_calender_section"
        ariaHideApp={false}
      >
        <Calendar
          onChange={onChange}
          value={value}
          next2Label={null}
          prev2Label={null}
          calendarType="US"
          className={["main-react-modal"]}
        />
      </Modal>
    </React.Fragment>
  );
};
